import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import moment from "moment";
import Modal from "react-modal";
import SimpleMap from "../../../components/gmaps";
import Select from "react-select";
import numberToWords from "number-to-words";

const SalesOrderForm = (props) => {
  const convertFloatToWords = (number) => {
    const words = numberToWords.toWords(number);
    const wordArray = words.split(" ");
    const decimalPart = Math.round(number * 100) % 100;
    if (decimalPart > 0) {
      const decimalWords = numberToWords.toWords(decimalPart);
      wordArray.push("and");
      wordArray.push(decimalWords);
    }

    return wordArray.join(" ");
  };
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "20%",
      borderRadius: "5px",
      maxWidth: "850px",
      maxHeight: "auto",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().substr(0, 10)
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const currentDate = new Date().toISOString().slice(0, 10);

  const frmRef = useRef({});
  const productRef = useRef({});
  const [productDetails, setProductDetails] = useState([]);
  const [customerDetails, setCustomerDetails] = useState([]);
  const [personDetails, setPersonDetails] = useState([]);

  const [customerId, setcustomerId] = useState(0);
  const [customerContactPersonId, setcustomerContactPersonId] = useState(0);

  const [close, setClose] = useState(false);

  const [rate, setRate] = useState(0);
  const [qty, setQty] = useState(0);
  const [qtyBalance, setQtyBalance] = useState(0);
  const [qtyBalanceUnit, setQtyBalanceUnit] = useState("");
  const [discount, setDiscount] = useState(0);

  const [exceptedDate, setExceptedDate] = useState("");
  const [docUrl, setDocUrl] = useState(false);

  const [subTotalAmount, setSubTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [billinglatLong, setBillinglatLong] = useState({
    lat: 18.644040659063442,
    lng: 73.72228501488648,
  });
  const [billingclose, setBillingclose] = useState(false);

  const [frieghtCharges, setfrieghtCharges] = useState(0);
  const [totalCostValue, setTotalCostValue] = useState(0);

  const [shippinglatLong, setShippinglatLong] = useState({
    lat: 18.644040659063442,
    lng: 73.72228501488648,
  });
  const [shippingclose, setShippingclose] = useState(false);
  const [itemSubType, setItemSubType] = useState();
  const [products, setProducts] = useState();
  const [selectedType, setSelectedType] = useState();
  const [selectedSubType, setSelectedSubType] = useState();
  const [selectedUnit, setSelectedUnit] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState();
  const [filterProducts, setFilterProducts] = useState();
  const [unitsData, setUnitsData] = useState();
  const [taxs, setTaxs] = useState();
  const [currancys, setCurrancys] = useState();
  const [selectionType, setSelectionType] = useState([]);
  const [selectionSubType, setSelectionSubType] = useState([]);
  const [selectionProduct, setSelectionProduct] = useState([]);
  const [selectionUnit, setSelectionUnit] = useState([]);
  const [editIndex, setEditIndex] = useState(-1);
  const [taxAmount, setTaxAmount] = useState(0);
  const [itemUnitPrice, setItemUnitPrice] = useState(0);

  const [taxId, setTaxId] = useState();
  const [costInWords, setCostInWords] = useState(0);
  const [entryLatLong, setEntryLatLong] = useState({
    lat: "",
    lng: "",
  });

  const formatDate = (date) => {
    if (!date) {
      return "";
    }

    const dateParts = date.split(/[\/ :]/);
    const day = dateParts[0];
    const month = dateParts[1];
    const year = dateParts[2];
    const time = dateParts[3] + ":" + dateParts[4] + ":" + dateParts[5];

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        setEntryLatLong({ lat, lng });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  const { sendRequest: getCustomer } = useHttp();

  const getCustomerDetail = (id) => {
    getCustomer(
      {
        url: `/api/customer/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setCustomerDetails(res);

          if (id > 0) {
            const filteredCustomer =
              res && res.filter((item) => item.customerId == id);

            setPersonDetails(
              filteredCustomer[0] && filteredCustomer[0].contactPersonDetails
            );

            frmRef.current.customer_id.value =
              filteredCustomer[0] && filteredCustomer[0].customerCode;
            frmRef.current.email.value =
              filteredCustomer[0] && filteredCustomer[0].emailId;
            frmRef.current.customer_id.value =
              filteredCustomer[0] && filteredCustomer[0].customerCode;
            frmRef.current.work_contact.value =
              filteredCustomer[0] && filteredCustomer[0].workContactNumber;
          }
        }
      }
    );
  };

  useEffect(() => {
    getCustomerDetail(0);
  }, [getCustomer]);

  const { sendRequest: postSalesOrder } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    if (productDetails.length === 0) {
      toast.error("Please add at least one product.");
      return;
    }
    const data = {
      createdBy: parseInt(localStorage.getItem("id")),
      salesOrderDetails: [
        {
          customerId: customerId,
          createdBy: parseInt(localStorage.getItem("id")),
          date: moment(frmRef.current.date.value).format("DD/MM/YYYY"),
          customerContactPersonId: customerContactPersonId,
          salesOrderProducts: productDetails,
          billingAddress: frmRef.current.bill_address.value,
          billingCity: frmRef.current.bill_city.value,
          billingState: frmRef.current.bill_state.value,
          billingZip: frmRef.current.bill_zipcode.value,
          billingCountry: frmRef.current.bill_country.value,
          billingLatLong: billinglatLong,

          is_shippingSameBillingAdd: frmRef.current.same_address.checked,
          shippingAddress: frmRef.current.shipp_address.value,
          shippingCity: frmRef.current.shipp_city.value,
          shippingState: frmRef.current.shipp_state.value,
          shippingZip: frmRef.current.shipp_zipcode.value,
          shippingCountry: frmRef.current.Shipp_country.value,
          shippingLatLong: shippinglatLong,

          currencyId: frmRef.current.currency.value,
          totalAmount: frmRef.current.total_amt.value,
          taxId: frmRef.current.tax.value,
          taxAmount: frmRef.current.tax_amt.value,
          expectedDate: moment(frmRef.current.excepted_date.value).format(
            "DD/MM/YYYY"
          ),
          terms: frmRef.current.terms.value,
          frieghtCharges: frieghtCharges,
          totalSalesOrderValue: frmRef.current.total_cost.value,
          remark: frmRef.current.remark.value,
          status: 1,

          orgId: parseInt(localStorage.getItem("orgId")),
          createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
          entryTime: moment().format("HH:mm:ss"),
          entryLatLong,
        },
      ],
    };

    if (props.update) {
      data.salesOrderDetails["salesOrderId"] = props.update.salesOrderId;
    }

    postSalesOrder(
      {
        url: "/api/salesOrder/",
        method: props.update ? "PUT" : "POST",
        body: data,
      },
      (data) => {
        toast.success(`Sales Order ${props.update ? "Updated" : "Added"}`);

        props.addForm(false);
      }
    );
  };

  const loadCustomerData = (id) => {
    const filteredCustomer =
      customerDetails &&
      customerDetails.filter((item) => item.customerId == id);

    setPersonDetails(
      filteredCustomer[0] && filteredCustomer[0].contactPersonDetails
    );

    frmRef.current.customer_id.value =
      filteredCustomer[0] && filteredCustomer[0].customerCode;
    frmRef.current.email.value =
      filteredCustomer[0] && filteredCustomer[0].emailId;
    frmRef.current.customer_id.value =
      filteredCustomer[0] && filteredCustomer[0].customerCode;
    frmRef.current.work_contact.value =
      filteredCustomer[0] && filteredCustomer[0].workContactNumber;

    var billingAddress = "";
    billingAddress =
      filteredCustomer[0] &&
      filteredCustomer[0].customerAddressDetails.find(
        (address) => address.addressType === "Billing"
      );

    if (!billingAddress) {
      billingAddress =
        filteredCustomer[0] &&
        filteredCustomer[0].customerAddressDetails.find(
          (address) => address.addressType === "Registered"
        );
    }

    if (billingAddress) {
      frmRef.current.bill_address.value = billingAddress.address;
      frmRef.current.bill_city.value = billingAddress.city;
      frmRef.current.bill_state.value = billingAddress.state;
      frmRef.current.bill_country.value = billingAddress.country;
      frmRef.current.bill_zipcode.value = billingAddress.zipCode;

      if (billingAddress.latLong) {
        setBillinglatLong({
          lat: billingAddress.latLong.lat,
          lng: billingAddress.latLong.lng,
        });
      }
    } else {
      setBillinglatLong({
        lat: 18.644040659063442,
        lng: 73.72228501488648,
      });
    }

    var shippAddress = "";
    shippAddress =
      (filteredCustomer[0] &&
        filteredCustomer[0].customerAddressDetails.find(
          (address) => address.addressType === "Shipping"
        )) ||
      "";

    if (!shippAddress) {
      shippAddress =
        filteredCustomer[0] &&
        filteredCustomer[0].customerAddressDetails.find(
          (address) => address.addressType === "Registered"
        );
    }

    if (shippAddress) {
      frmRef.current.shipp_address.value = shippAddress.address;
      frmRef.current.shipp_city.value = shippAddress.city;
      frmRef.current.shipp_state.value = shippAddress.state;
      frmRef.current.Shipp_country.value = shippAddress.country;
      frmRef.current.shipp_zipcode.value = shippAddress.zipCode;

      if (shippAddress.latLong) {
        setShippinglatLong(shippAddress.latLong);
      }
    }
    var registredAddress = "";
    registredAddress =
      (filteredCustomer[0] &&
        filteredCustomer[0].customerAddressDetails.find(
          (address) => address.addressType === "Registered"
        )) ||
      "";
  };

  const handleCustomerChange = (e) => {
    const id = e.target.value;

    setcustomerId(id);
    loadCustomerData(id);
  };

  function setAddr() {
    frmRef.current.shipp_address.value = frmRef.current.bill_address.value;
    frmRef.current.shipp_city.value = frmRef.current.bill_city.value;
    frmRef.current.shipp_state.value = frmRef.current.bill_state.value;
    frmRef.current.shipp_zipcode.value = frmRef.current.bill_zipcode.value;
    frmRef.current.Shipp_country.value = frmRef.current.bill_country.value;
  }
  function clearAddr() {
    frmRef.current.shipp_address.value = "";
    frmRef.current.shipp_city.value = "";
    frmRef.current.shipp_state.value = "";
    frmRef.current.shipp_zipcode.value = "";
    frmRef.current.Shipp_country.value = "";
  }

  const setOfficeAddr = () => {
    if (frmRef.current.same_address.checked) {
      setAddr();
    } else {
      clearAddr();
    }
  };

  useEffect(() => {
    if (rate == "" || qty == "") {
      setSubTotal(0);
    }

    const sum = parseFloat(rate) * parseFloat(qty);
    setSubTotal(sum);
  }, [rate, qty]);

  useEffect(() => {}, [subTotalAmount, discount]);

  const submitProduct = (e) => {
    e.preventDefault();
    const productName = selectedProduct && selectedProduct.label;
    const itemTypeName = selectedType && selectedType.label;
    const itemSubTypeName = selectedSubType && selectedSubType.label;
    const itemQuantity = productRef.current.itemQuantity.value;
    const itemUnitPrice = productRef.current.itemUnitPrice.value;
    const subTotalAmount = productRef.current.pro_sub_total.value;
    const discount = productRef.current.discount.value;
    const discountAmount = productRef.current.discountAmount.value;
    const rate = productRef.current.rate.value;
    const unit = selectedUnit && selectedUnit.label;

    if (
      !productName ||
      !itemTypeName ||
      !itemSubTypeName ||
      !itemQuantity ||
      !itemUnitPrice ||
      !subTotalAmount ||
      !discount ||
      !discountAmount ||
      !rate ||
      !unit
    ) {
      toast.success("Please fill in all fields!");

      return;
    } else {
      const productName = selectedProduct && selectedProduct.label;
      const isDuplicate = productDetails.some(
        (product) => product.productName === productName
      );
      if (isDuplicate) {
        toast.success("Item already exists!");

        return;
      }
      setProductDetails((x) => [
        ...x,
        {
          lineSrNo: productDetails.length + 1,
          productId: selectedProduct && selectedProduct.value,
          productName: selectedProduct && selectedProduct.label,

          productTypeName: selectedType && selectedType.label,
          productTypeId: selectedType && selectedType.value,
          productSubTypeName: selectedSubType && selectedSubType.label,
          productSubTypeId: selectedSubType && selectedSubType.value,
          salesOrderQuantity: productRef.current.itemQuantity.value || 0,
          salesOrderQuantityBalance: productRef.current.itemQuantity.value || 0,
          unitId: selectedUnit && selectedUnit.value,
          unitName: selectedUnit && selectedUnit.label,
          itemUnitPrice: productRef.current.itemUnitPrice.value,
          rate: rate,
          subTotalAmount: subTotalAmount,
          discount: discount,
          discountAmount: productRef.current.discountAmount.value,
          totalLineAmount: totalAmount,
          createdBy: parseInt(localStorage.getItem("id")),
          status: 1,
          orgId: parseInt(localStorage.getItem("orgId")),
          createdDate: moment().format("DD/MM/YYYY hh:mm:ss"),
          entryTime: moment().format("HH:mm:ss"),
          entryLatLong,
        },
      ]);

      setSelectedUnit({});
      setSelectedProduct({});
      setSelectedSubType({});
      setSelectedType({});

      productRef.current.itemUnitPrice.value = 0;
      productRef.current.rate.value = 0;
      productRef.current.itemQuantity.value = 0;
      setRate(0);
      setQty(0);
      setDiscount(0);
      setItemUnitPrice(0);
    }

    setTotalValue();
  };

  const setTotalValue = () => {
    let acc = 0;

    productDetails.forEach((x) => {
      acc += parseFloat(x.totalLineAmount);
    });
    setTotalAmount(acc);
    setGrandTotal(acc);

    var taxAmt = 0;
    if (taxId > 0) {
      const filteredTaxPer =
        taxs &&
        taxs
          .filter((item) => parseInt(item.taxId) === parseInt(taxId))
          .map((item) => item.taxPercentage);

      taxAmt =
        (filteredTaxPer &&
          parseFloat((acc / 100) * filteredTaxPer).toFixed(2)) ||
        0;

      setTaxAmount(taxAmt);
    }

    setTotalCostValue(
      parseFloat(acc) + parseFloat(taxAmt) + parseFloat(frieghtCharges) || 0
    );
  };

  useEffect(() => {
    if (close) {
      setTotalValue();
    }
  }, [productDetails, discount]);

  const handleDelete = (index, e) => {
    setProductDetails(productDetails.filter((v, i) => i !== index));
    setTotalValue();
  };

  const viewPdf = (e) => {
    e.preventDefault();
    setDocUrl("https://www.orimi.com/pdf-test.pdf");
  };

  const handleBillingLatLong = () => {
    if (!billinglatLong) {
      setBillinglatLong({
        lat: 18.644040659063442,
        lng: 73.72228501488648,
      });
    }

    setBillingclose(true);
  };
  const handleShippingLatLong = () => {
    setShippingclose(true);
  };

  const { sendRequest: getunits } = useHttp();

  useEffect(() => {
    getunits(
      {
        url: `/api/units?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setUnitsData(res);
        }
      }
    );
  }, [getunits]);

  const { sendRequest: getTaxs } = useHttp();

  const getAllTax = () => {
    getTaxs(
      {
        url: `/api/tax/`,
      },
      (res) => {
        setTaxs(res);
      }
    );
  };

  useEffect(() => {
    getAllTax();
  }, [taxId]);

  const { sendRequest: getCurrency } = useHttp();

  useEffect(() => {
    getCurrency(
      {
        url: `/api/currencies/`,
      },
      (res) => {
        if (res) {
          setCurrancys(res);
        }
      }
    );
  }, [getCurrency]);

  const { sendRequest: getItemType } = useHttp();

  useEffect(() => {
    getItemType(
      {
        url: `/api/getOnlineProductType/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          var productitemtypes = res.filter(
            (item) =>
              item.productTypeNo == "FP" ||
              item.productTypeNo == "SD" ||
              item.productTypeNo == "FE" ||
              item.productTypeNo == "AG"
          );

          setSelectionType(
            productitemtypes.map((x) => ({
              value: x.productItemTypeId,
              label: x.productTypeName,
            }))
          );
          setSelectionSubType([]);
        }
      }
    );
  }, [getItemType]);

  const { sendRequest: getSubItem } = useHttp();

  useEffect(() => {
    getSubItem(
      {
        url: `/api/getOnlineProductSubItem/?orgId=${localStorage.getItem(
          "orgId"
        )}`,
      },
      (res) => {
        if (res) {
          setItemSubType(res);
        }
      }
    );
  }, [getSubItem]);

  const { sendRequest: getProducts } = useHttp();

  useEffect(() => {
    getProducts(
      {
        url: `/api/getOnlineProducts/?orgId=${localStorage.getItem("orgId")}`,
      },
      (res) => {
        if (res) {
          setProducts(res);
        }
      }
    );
  }, [getProducts]);

  const handleTypeChange = (option) => {
    setSelectedType(option);
    setSelectedProduct([]);
    setSelectedUnit([]);
    setSelectedSubType([]);
  };

  useEffect(
    (e) => {
      const filteredData =
        itemSubType &&
        selectedType &&
        itemSubType.filter(
          (item) =>
            parseInt(item.productTypeId) ===
            parseInt(selectedType && selectedType.value)
        );

      setSelectionSubType(
        filteredData &&
          filteredData.map((x) => ({
            value: x.productSubTypeId,
            label: x.productSubTypeName,
          }))
      );
    },
    [selectedType]
  );

  //filter products

  const handleSubTypeChange = (option) => {
    setSelectedSubType(option);
    setSelectedProduct([]);
    setSelectedUnit([]);
  };

  useEffect(
    (e) => {
      const filteredProData =
        products &&
        products.filter(
          (item) =>
            parseInt(item.productSubTypeId) ===
            parseInt(selectedSubType && selectedSubType.value)
        );

      //  console.log(filteredProData);

      setFilterProducts(filteredProData);

      setSelectionProduct(
        filteredProData &&
          filteredProData.map((x) => ({
            value: x.productId,
            label: x.productName,
          }))
      );
    },
    [selectedSubType]
  );

  //filter units
  const handleProdcutChange = (option) => {
    if (option) {
      setSelectedProduct(option);
      setSelectedUnit([]);
    }
  };

  useEffect(
    (e) => {
      if (selectedProduct) {
        const productsData =
          filterProducts &&
          filterProducts
            .filter(
              (item) =>
                parseInt(item.productId) ===
                parseInt(selectedProduct && selectedProduct.value)
            )
            .map((item) => item);

        console.log(productsData);

        if (selectedProduct.value) {
          setItemUnitPrice(
            (productsData && productsData[0].itemUnitPrice) || 0
          );
          setDiscount((productsData && productsData[0].discount) || 0);

          setQtyBalance((productsData && productsData[0].quantityBalance) || 0);
          setQtyBalanceUnit(
            (productsData && productsData[0].quantityUnit) || 0
          );

          const id = productsData && productsData[0].unitId; //unit id

          const filteredUnits =
            unitsData &&
            unitsData
              .filter(
                (item) => parseInt(item.unitId) === parseInt(id) //filter unit type id
              )
              .map((item) => item.unitTypeId);

          const TypeId = (filteredUnits && filteredUnits[0]) || 0;

          const uData =
            unitsData &&
            unitsData.filter(
              (item) => parseInt(item.unitTypeId) === parseInt(TypeId) //filter all units
            );

          // set unit data

          setSelectionUnit(
            uData &&
              uData.map((x) => ({
                value: x.unitId,
                label: x.unitName,
              }))
          );
        }
      }
    },
    [selectedProduct]
  );
  const handleUnitChange = (option) => {
    setSelectedUnit(option);
  };
  useEffect((e) => {}, [selectedUnit]);

  const customStyles = {
    control: (base, state) => ({
      ...base,
      overflow: "hidden",
      width: "150px",
      height: "20p",
      margin: "3px",
    }),
    dropdownContainer: (base, state) => ({
      ...base,
      gridTemplateRows: "0 min-content",
    }),
  };

  const handleTaxChange = (e) => {
    setTaxId(e.target.value);
  };
  useEffect(() => {
    const filteredTaxPer =
      taxs &&
      taxs
        .filter((item) => parseInt(item.taxId) === parseInt(taxId))
        .map((item) => item.taxPercentage);
    // //console.log(filteredTaxPer);

    const taxAmt =
      (filteredTaxPer &&
        parseFloat((grandTotal / 100) * filteredTaxPer).toFixed(2)) ||
      0;

    // //console.log(taxAmt);
    setTaxAmount(taxAmt);
  }, [taxId, totalAmount, taxAmount, productDetails]);

  useEffect(() => {
    setTotalCostValue(
      parseFloat(grandTotal) +
        parseFloat(taxAmount) +
        parseFloat(frieghtCharges) || 0
    );
  }, [totalAmount, taxAmount, frieghtCharges, taxId]);

  useEffect(() => {
    setTotalAmount(
      parseFloat(subTotalAmount - (discount * subTotalAmount) / 100).toFixed(
        2
      ) || 0
    );
  }, [discount, subTotalAmount]);

  useEffect(() => {
    // //console.log("Tax amt", parseFloat(props.update.taxAmount));

    if (props.update) {
      setcustomerId(props.update.customerId);
      getCustomerDetail(props.update.customerId);

      frmRef.current.customer_name.value = props.update.customerId;
      setcustomerContactPersonId(props.update.customerContactPersonId);

      frmRef.current.contact_person_name.value =
        props.update.customerContactPersonId;

      frmRef.current.bill_address.value = props.update.billingAddress;
      frmRef.current.bill_city.value = props.update.billingCity;
      frmRef.current.bill_state.value = props.update.billingState;
      frmRef.current.bill_zipcode.value = props.update.billingZip;
      frmRef.current.bill_country.value = props.update.billingCountry;
      setBillinglatLong(props.update.billingLatLong);

      frmRef.current.same_address.checked =
        props.update.is_shippingSameBillingAdd;

      frmRef.current.shipp_address.value = props.update.shippingAddress;
      frmRef.current.shipp_city.value = props.update.shippingCity;
      frmRef.current.shipp_state.value = props.update.shippingState;
      frmRef.current.shipp_zipcode.value = props.update.shippingZip;
      frmRef.current.Shipp_country.value = props.update.shippingCountry;
      setShippinglatLong(props.update.shippingLatLong);

      setProductDetails(props.update.salesOrderProducts);
      setGrandTotal(props.update.totalAmount);
      frmRef.current.currency.value = props.update.currencyId;
      frmRef.current.total_amt.value = props.update.totalAmount;

      setTotalAmount(props.update.totalAmount);
      setGrandTotal(props.update.totalAmount);

      setTaxId(props.update.taxId);
      setTaxAmount(120);

      setExceptedDate(formatDate(props.update.expectedDate));
      frmRef.current.excepted_date.value = formatDate(
        props.update.expectedDate
      );
      frmRef.current.terms.value = props.update.terms;
      setfrieghtCharges(props.update.frieghtCharges);
      frmRef.current.total_cost.value = props.update.totalSalesOrderValue;

      setTotalCostValue(props.update.totalSalesOrderValue);
      frmRef.current.remark.value = props.update.remark;
    }
  }, [props.update]);

  useEffect(() => {
    const totalCost1 = totalCostValue || 0;
    const totalCostInWords = convertFloatToWords(totalCost1);
    // console.log(totalCost1);
    setCostInWords(totalCostInWords);
  }, [totalCostValue]);
  return (
    <>
      {billingclose && (
        <Modal onClose={setBillingclose} isOpen={true} style={modalStyles}>
          <div className="text-center">
            <SimpleMap
              lat={billinglatLong.lat}
              lng={billinglatLong.lng}
              set={setBillinglatLong}
              close={setBillingclose}
            />
          </div>
        </Modal>
      )}
      {shippingclose && (
        <Modal onClose={setShippingclose} isOpen={true} style={modalStyles}>
          <SimpleMap
            lat={shippinglatLong.lat}
            lng={shippinglatLong.lng}
            set={setShippinglatLong}
            close={setShippingclose}
          />
        </Modal>
      )}
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <form onSubmit={submitHandler}>
                <div className="card-header">
                  <h3 className="card-title">Sales Order Form</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}> {"Date"}</label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["date"] = el)}
                        className="form-control"
                        max={currentDate}
                        //value={selectedDate}
                        value={
                          props.update.date
                            ? props.update.date.split("/").reverse().join("-")
                            : selectedDate
                        }
                        onChange={handleDateChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"customer_name"}>
                        {" "}
                        {"Customer Name"}
                      </label>
                      <select
                        id="customer_name"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["customer_name"] = el)}
                        value={customerId}
                        onChange={handleCustomerChange}
                        required
                      >
                        <option value="">Select</option>
                        {customerDetails &&
                          customerDetails.map((x) => (
                            <option
                              key={x.customerId}
                              value={x.customerId}
                              selected={
                                props.update &&
                                x.customerId === props.update.customerId
                              }
                            >
                              {x.name}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"customer_id"}> {"Customer Code"}</label>
                      <input
                        type={"text"}
                        id={"customer_id"}
                        required
                        ref={(el) => (frmRef.current["customer_id"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"contact_person_name"}>
                        {" "}
                        {"Contact Person Name"}
                      </label>

                      <select
                        id="contact_person_name"
                        className="form-control dropdowns"
                        ref={(el) =>
                          (frmRef.current["contact_person_name"] = el)
                        }
                        value={customerContactPersonId}
                        required
                        onChange={(e) => {
                          setcustomerContactPersonId(e.target.value);
                        }}
                      >
                        <option value="">Select</option>
                        {personDetails &&
                          personDetails.map((x) => (
                            <option
                              key={x.customerContactPersonId}
                              value={x.customerContactPersonId}
                            >
                              {x.name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"work_contact"}>
                        {"Contact Number(Work)"}
                      </label>
                      <input
                        type={"text"}
                        id={"work_contact"}
                        required
                        ref={(el) => (frmRef.current["work_contact"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"email"}> {"Email Id"}</label>
                      <input
                        type={"email"}
                        id={"email"}
                        required
                        ref={(el) => (frmRef.current["email"] = el)}
                        className="form-control"
                        disabled
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"currency"}> {"Currency"}</label>
                      <select
                        id="currency"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["currency"] = el)}
                        required
                      >
                        <option value="">Select</option>
                        {currancys &&
                          currancys.map((x) => (
                            <option
                              key={x.currencyId}
                              value={x.currencyId}
                              selected={
                                props.update &&
                                x.currencyId === props.update.currencyId
                              }
                            >
                              {x.country.currencyName}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"terms"}>{"Terms(if Any)"}</label>
                      <input
                        type={"text"}
                        id={"terms"}
                        ref={(el) => (frmRef.current["terms"] = el)}
                        className="form-control"
                        required
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"bill_address"}>
                        {" "}
                        {"Billing Address"}
                      </label>
                      <input
                        type={"text"}
                        id={"bill_address"}
                        required
                        ref={(el) => (frmRef.current["bill_address"] = el)}
                        className="form-control"
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"bill_city"}> {"City"}</label>
                      <input
                        type={"text"}
                        id={"bill_city"}
                        required
                        ref={(el) => (frmRef.current["bill_city"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"bill_state"}>
                        {" "}
                        {"State/Province/Region"}
                      </label>
                      <input
                        type={"text"}
                        id={"bill_state"}
                        required
                        ref={(el) => (frmRef.current["bill_state"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"Zip Code (Postal Code)"}>
                        {" "}
                        {"Zip Code (Postal Code)"}
                      </label>
                      <input
                        type={"text"}
                        id={"bill_zipcode"}
                        required
                        ref={(el) => (frmRef.current["bill_zipcode"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"bill_country"}>{"Country"}</label>
                      <input
                        type={"text"}
                        id={"bill_country"}
                        required
                        ref={(el) => (frmRef.current["bill_country"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"billinglatLong"}> {"Lat/Long"}</label>
                      <br />
                      &nbsp;&nbsp;&nbsp;
                      <button
                        type={"button"}
                        className="btn btn-warning btn-sm"
                        onClick={(e) => {
                          handleBillingLatLong(e);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <hr />
                  <div className="row mb-2">
                    <div className="col-md-12 mb-2">
                      <div className="form-check ">
                        <input
                          type={"checkbox"}
                          id={"same_address"}
                          ref={(el) => (frmRef.current["same_address"] = el)}
                          className="form-check-input"
                          onClick={setOfficeAddr}
                        />
                        <label
                          htmlFor={"same_address"}
                          className="form-check-label"
                        >
                          {"Shipping Address same as  Billing Address"}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"Shipping Address"}>
                        {" "}
                        {"Shipping Address"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_address"}
                        required
                        ref={(el) => (frmRef.current["shipp_address"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shipp_city"}> {"City"}</label>
                      <input
                        type={"text"}
                        id={"shipp_city"}
                        required
                        ref={(el) => (frmRef.current["shipp_city"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shipp_state"}>
                        {"State/Province/Region"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_state"}
                        required
                        ref={(el) => (frmRef.current["shipp_state"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shipp_zipcode"}>
                        {"Zip Code (Postal Code)"}
                      </label>
                      <input
                        type={"text"}
                        id={"shipp_zipcode"}
                        required
                        ref={(el) => (frmRef.current["shipp_zipcode"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"Shipp_country"}>{"Country"}</label>
                      <input
                        type={"text"}
                        id={"Shipp_country"}
                        required
                        ref={(el) => (frmRef.current["Shipp_country"] = el)}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"shippinglatLong"}> {"Lat/Long"}</label>
                      <br />
                      &nbsp;&nbsp;&nbsp;
                      <button
                        type="button"
                        className="btn btn-warning btn-sm"
                        onClick={(e) => {
                          handleShippingLatLong(e);
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                  <hr></hr>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"product_details"}>
                        {" "}
                        {"Product Details"}
                      </label>
                      <br />
                      &nbsp;&nbsp;
                      <button
                        type="button"
                        id={"product_details"}
                        formNoValidate="True"
                        onClick={() => {
                          productDetails &&
                            setProductDetails((items) =>
                              items.filter((x) => x.isSave || x.salesOrderId)
                            );

                          setClose(true);
                        }}
                        ref={(el) => (frmRef.current["product_details"] = el)}
                        className="btn btn-sm btn-success"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_amt"}>{"Total Amount"}</label>
                      <input
                        type={"text"}
                        id={"total_amt"}
                        required
                        disabled
                        value={grandTotal}
                        ref={(el) => (frmRef.current["total_amt"] = el)}
                        className="form-control currancy-value"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax"}> {"Tax"}</label>
                      <select
                        id="tax"
                        className="form-control dropdowns"
                        ref={(el) => (frmRef.current["tax"] = el)}
                        onChange={handleTaxChange}
                      >
                        <option value="">Select</option>
                        {taxs &&
                          taxs.map((x) => (
                            <option
                              key={x.taxId}
                              value={x.taxId}
                              selected={
                                props.update && x.taxId == props.update.taxId
                              }
                            >
                              {x.taxName}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"tax_amt"}>{"Tax Amount"}</label>
                      <input
                        type={"text"}
                        id={"tax_amt"}
                        required
                        value={taxAmount}
                        ref={(el) => (frmRef.current["tax_amt"] = el)}
                        className="form-control currancy-value"
                        disabled
                      />
                    </div>
                  </div>
                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"frieght_charges"}>
                        {"Frieght Charges"}
                      </label>
                      <input
                        type={"text"}
                        id={"frieght_charges"}
                        required
                        ref={(el) => (frmRef.current["frieght_charges"] = el)}
                        value={frieghtCharges}
                        onChange={(e) => setfrieghtCharges(e.target.value)}
                        className="form-control currancy-value"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"total_cost"}>
                        {"Total Purchase Cost/Value"}
                      </label>
                      <input
                        type={"text"}
                        id={"total_cost"}
                        required
                        disabled
                        value={parseFloat(totalCostValue).toFixed(2)}
                        ref={(el) => (frmRef.current["total_cost"] = el)}
                        className="form-control currancy-value"
                      />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor={"amt_chargeable"}>
                        {" "}
                        {"Amount Chargeable"}
                      </label>
                      <textarea
                        id={"amt_chargeable"}
                        required
                        ref={(el) => (frmRef.current["amt_chargeable"] = el)}
                        value={costInWords}
                        rows="2"
                        cols="25"
                        style={{ resize: "none" }}
                        disabled
                      ></textarea>
                    </div>
                  </div>

                  <div className="row mb-2">
                    <div className="col-md-3">
                      <label htmlFor={"date"}>
                        {" "}
                        {"Expected Delivery Date"}
                      </label>
                      <input
                        type={"date"}
                        id={"date"}
                        required
                        ref={(el) => (frmRef.current["excepted_date"] = el)}
                        className="form-control"
                        min={selectedDate}
                        value={exceptedDate}
                        onChange={(e) => setExceptedDate(e.target.value)}
                      />
                    </div>

                    <div className="col-md-3">
                      <label htmlFor={"remark"}>{"Remark/Note"}</label>
                      <input
                        type={"text"}
                        id={"remark"}
                        required
                        ref={(el) => (frmRef.current["remark"] = el)}
                        className="form-control"
                      />
                    </div>
                  </div>
                  <div className=" text-right">
                    <button type="submit" className="btn btn-primary">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>

      {close && (
        <Modal isOpen={true} style={modalStyles}>
          <div className="">
            <h3 className="card-title">Product Details</h3>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setClose(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
          </div>

          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"itemType"}>Item Type</label>

              <Select
                styles={customStyles}
                options={selectionType}
                value={selectedType}
                onChange={(option) => {
                  handleTypeChange(option);
                }}
                required
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"itemCategory"}> Item Category</label>

              <Select
                styles={customStyles}
                options={selectionSubType}
                value={selectedSubType}
                onChange={(option) => {
                  handleSubTypeChange(option);
                }}
                required
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"itemDescription"}> Item Description</label>

              <Select
                styles={customStyles}
                options={selectionProduct}
                value={selectedProduct}
                onChange={(option) => {
                  handleProdcutChange(option);
                }}
                required
              />
            </div>

            <div className="col-md-3">
              <label htmlFor={"itemUnitPrice"}>Item Unit Price</label>
              <input
                type={"number"}
                id={"itemUnitPrice"}
                required
                ref={(el) => (productRef.current["itemUnitPrice"] = el)}
                className="form-control"
                value={itemUnitPrice}
                readOnly
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"rate"}>Rate</label>
              <input
                type={"number"}
                id={"rate"}
                required
                ref={(el) => (productRef.current["rate"] = el)}
                className="form-control"
                value={rate}
                onChange={(e) => setRate(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"quantityBalance"}>Quantity Balance</label>
              <div className="row">
                <div className="col-md-9">
                  <input
                    type={"number"}
                    id={"quantityBalance"}
                    className="form-control"
                    value={qtyBalance || 0}
                    readOnly
                  />
                </div>
                <div className="col-md-3 text-left">
                  <p htmlFor={"quantityBalance"}>
                    {" " + qtyBalanceUnit || ""}
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-3">
              <label htmlFor={"itemQuantity"}> Item Quantity</label>
              <input
                type={"number"}
                id={"itemQuantity"}
                required
                ref={(el) => (productRef.current["itemQuantity"] = el)}
                className="form-control"
                value={qty}
                onChange={(e) => setQty(e.target.value)}
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"unit"}> Unit</label>

              <Select
                styles={customStyles}
                options={selectionUnit}
                value={selectedUnit}
                onChange={(option) => {
                  handleUnitChange(option);
                }}
                required
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-3">
              <label htmlFor={"pro_sub_total"}>Sub Total</label>
              <input
                type={"number"}
                id={"pro_sub_total"}
                required
                value={subTotalAmount}
                ref={(el) => (productRef.current["pro_sub_total"] = el)}
                className="form-control currancy-value"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"discount"}>Discount%</label>
              <input
                type={"number"}
                id={"discount"}
                required
                value={discount}
                onChange={(e) => setDiscount(e.target.value)}
                ref={(el) => (productRef.current["discount"] = el)}
                className="form-control currancy-value"
                readOnly
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"discountAmount"}>Discounted Amount</label>
              <input
                type={"number"}
                id={"discountAmount"}
                required
                disabled
                value={(discount * subTotalAmount) / 100}
                ref={(el) => (productRef.current["discountAmount"] = el)}
                className="form-control currancy-value"
              />
            </div>
            <div className="col-md-3">
              <label htmlFor={"totalAmount"}>Total Amount</label>
              <input
                type={"input"}
                id={"totalAmount"}
                required
                disabled
                value={totalAmount}
                ref={(el) => (productRef.current["totalAmount"] = el)}
                className="form-control  currancy-value"
              />
            </div>
            <div className="col-md-3">
              <br /> &nbsp;&nbsp;
              <button
                className="btn btn-success btn-sm"
                onClick={submitProduct}
              >
                +
              </button>
            </div>
          </div>
          <hr />
          <div className="row">
            <table className="table-bordered table table-sm table-responsive">
              <thead className="">
                <tr className="tableheaderrowview">
                  <th>Sr. No</th>
                  <th>Item Type</th>
                  <th>Item Category</th>
                  <th>Item Description</th>
                  <th>Item Unit Price</th>
                  <th>Rate</th>
                  <th>Item Quantity</th>
                  <th>Unit</th>
                  <th>Amount</th>
                  <th>Discount</th>
                  <th>Discount Amount</th>
                  <th>Total</th>
                  <th>Delete</th>
                </tr>
              </thead>

              <tbody>
                {productDetails &&
                  productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{itm.lineSrNo}</td>
                        <td>{itm.productTypeName}</td>
                        <td>{itm.productSubTypeName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.itemUnitPrice}</td>
                        <td>{itm.rate}</td>
                        <td>{itm.salesOrderQuantity}</td>
                        <td>{itm.unitName}</td>
                        <td>{itm.subTotalAmount}</td>
                        <td>{itm.discount}</td>
                        <td>{itm.discountAmount}</td>
                        <td>{itm.totalLineAmount}</td>

                        <td>
                          <button
                            className="btn"
                            onClick={(e) => handleDelete(i, e)}
                          >
                            <i className="fas fa-trash"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>

          <div className="text-center">
            <button
              className="btn btn-sm btn-primary"
              onClick={() => {
                productDetails &&
                  productDetails.map((x) => (x["isSave"] = true));
                setClose(false);
              }}
            >
              Save
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

export default SalesOrderForm;
